/**
 * Environment access — v.1-D §7.1.
 *
 * Vite exposes user-facing variables under `import.meta.env` at build time.
 * `readRequired` throws when a required value is missing so the failure is
 * loud and immediate; `readOptional` falls back to a documented default.
 *
 * The COOKIE_DOMAIN default permits local-dev sign-in on `localhost` without
 * breaking production cross-domain cookies (see §7.4, Decision D-017).
 */
function readRequired(name: string): string {
  const value = import.meta.env[name];
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(
      `Environment variable ${name} is not set. Copy .env.example to .env.local and fill in the value.`,
    );
  }
  return value;
}

function readOptional(name: string, fallback: string): string {
  const value = import.meta.env[name];
  return typeof value === 'string' && value.length > 0 ? value : fallback;
}

export const env = {
  CONVEX_URL: readRequired('VITE_CONVEX_URL'),
  PAYLOAD_URL: readRequired('VITE_PAYLOAD_URL'),
  COOKIE_DOMAIN: readOptional('VITE_COOKIE_DOMAIN', '.mediatiquepress.one'),
  LOG_LEVEL: readOptional(
    'VITE_LOG_LEVEL',
    import.meta.env.DEV ? 'debug' : 'info',
  ),
  IS_DEV: import.meta.env.DEV,
};
